import type { ReactNode } from 'react';

interface SectionHeadingProps {
  index: string;
  label: string;
  title: string;
  desc: string;
  align?: 'left' | 'between';
  extra?: ReactNode;
}

export default function SectionHeading({
  index,
  label,
  title,
  desc,
  align = 'between',
  extra,
}: SectionHeadingProps) {
  return (
    <div
      className={
        align === 'between'
          ? 'flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between'
          : 'flex flex-col gap-4'
      }
    >
      <div className="max-w-2xl">
        <div className="flex items-center gap-3">
          <span className="font-heading text-sm font-bold text-primary-500">{index}</span>
          <span className="h-px w-8 bg-primary-300"></span>
          <span className="text-xs font-label tracking-[0.18em] uppercase text-foreground-500">{label}</span>
        </div>
        <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        <p className="mt-3 text-sm leading-7 text-foreground-600">{desc}</p>
      </div>
      {extra ? <div className="shrink-0">{extra}</div> : null}
    </div>
  );
}